import { useCallback } from 'react';
import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router';

interface Props {
  replace?: boolean;
}

const useNav = (props?: Props) => {
  const { replace = true } = props || {};
  const navigate = useNavigate();

  const nav: NavigateFunction = useCallback(
    (to: To | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
      } else {
        navigate(to, Object.assign({ replace }, options));
      }
    },
    [navigate, replace]
  );

  return nav;
};

export default useNav;
